import { render, staticRenderFns } from "./OrgHierarchy.vue?vue&type=template&id=6e455d96&scoped=true&"
import script from "./OrgHierarchy.vue?vue&type=script&lang=js&"
export * from "./OrgHierarchy.vue?vue&type=script&lang=js&"
import style0 from "./OrgHierarchy.vue?vue&type=style&index=0&id=6e455d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e455d96",
  null
  
)

export default component.exports